import { render, staticRenderFns } from "./ShareableWaiver.vue?vue&type=template&id=4ffa94ad&scoped=true"
import script from "./ShareableWaiver.vue?vue&type=script&lang=js"
export * from "./ShareableWaiver.vue?vue&type=script&lang=js"
import style0 from "./ShareableWaiver.vue?vue&type=style&index=0&id=4ffa94ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffa94ad",
  null
  
)

export default component.exports